module.exports = " <section class=section> <div class=container> <div class=heading> <h2 class=\"title is-2\">Table</h2> <h2 class=\"subtitle is-4\"> 摩斯電碼對照表 </h2> <p class=\"subtitle is-6\">點擊字母或符號，會播放對應的摩斯電碼音效。</p> </div> <code-table title=Alphabets subtitle=英文字母 :codes=alphabets :encode=Encode :play=Play></code-table> <code-table title=Numbers subtitle=數字 :codes=numbers :encode=Encode :play=Play></code-table> <code-table title=Symbols subtitle=符號 :codes=symbols :encode=Encode :play=Play></code-table> <codes :play=Play></codes> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeTables.vue
 ** module id = 159
 ** module chunks = 2
 **/